/**
 *
 * Last Modified Time: Thu Oct 08 2020 10:40:57 GMT-0400 (Eastern Daylight Time)
 * Figma Version:  488873946
 *
 */
export const gray800 = "#19191b";
export const gray600 = "#404042";
export const gray400 = "#6e7071";
export const gray200 = "#a5a5a5";
export const gray100 = "#e6e8eb";
export const gray50 = "#f9f9f9";
export const lighterYellow = "#f3ecbb";
export const lighterRed = "#fcd1a1";
export const lightYellow = "#f3d95a";
export const yellow = "#ebc627";
export const lightRed = "#ec8e4e";
export const red = "#e15c18";
export const darkYellow = "#caa51c";
export const darkRed = "#c14111";
export const lighterPurple = "#f6e4f5";
export const lightPurple = "#d6c0d8";
export const purple = "#baa3bf";
export const darkPurple = "#9877a4";
export const darkerPurple = "#56336e";
export const darkerYellow = "#88690c";
export const darkerRed = "#821907";
export const lighterBlue = "#9eeaef";
export const lightBlue = "#80d3df";
export const blue = "#58b3ca";
export const darkBlue = "#408fad";
export const darkerBlue = "#1c4f75";
export const lighterGreen = "#b8f2c2";
export const lightGreen = "#6bd9a1";
export const green = "#24a06d";
export const darkGreen = "#158562";
export const darkerGreen = "#0b5c53";
export const lighterMint = "#e0fce5";
export const lightMint = "#bceccf";
export const mint = "#a3e1c2";
export const darkMint = "#77c1a3";
export const darkerMint = "#338272";
